import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { HTTP_CACHE_CONFIG } from '@core/http/providers/http-cache.provider';
import { map, of, switchMap } from 'rxjs';
import { HttpCacheService } from '@core/http/services/http-cache.service';

export const httpCacheInterceptor: HttpInterceptorFn = (req, next) => {
    const config = inject(HTTP_CACHE_CONFIG);
    const cacheService = inject(HttpCacheService);
    const needsCaching = config?.endpoints?.some((e) => req.url.includes('/' + e));
    if (needsCaching) {
        cacheService.initCache();
        const cachedResponse = cacheService.retrieveResponse(req.url);
        if (cachedResponse) {
            return of(
                new HttpResponse({
                    body: cachedResponse.body,
                }),
            );
        } else {
            return next(req).pipe(
                switchMap((event) => {
                    if (event instanceof HttpResponse) {
                        return cacheService.cacheResponse(req.url, event).pipe(map(() => event));
                    } else {
                        return of(event);
                    }
                }),
            );
        }
    } else {
        return next(req);
    }
};
